import type { PageMeta } from '../../api';
import { pageWindow, PagerNav } from './ListPager';

interface PaginationProps {
  meta: PageMeta | null | undefined;
  onPageChange: (page: number) => void;
  /** Drop the bar's own top border and padding — for a card footer that has its own. */
  bare?: boolean;
}

/**
 * Page navigation for a server-paginated list (the API's PageMeta). Renders nothing for a
 * single page. It draws the SAME bar as ListPager (the client-side pager) so every list in the
 * app pages the same way — one look, one set of controls.
 */
export default function Pagination({ meta, onPageChange, bare = false }: PaginationProps) {
  if (!meta || meta.totalPages <= 1) return null;
  const { page, totalPages, total } = meta;
  return (
    <div className={`flex flex-col items-center justify-between gap-2 sm:flex-row ${bare ? '' : 'border-t border-border px-4 py-3'}`}>
      <p className="text-[12px] text-muted-foreground">
        Page <span className="font-semibold text-foreground">{page}</span> of{' '}
        <span className="font-semibold text-foreground">{totalPages}</span> • {total} total
      </p>
      <PagerNav current={page} pages={pageWindow(page, totalPages)} totalPages={totalPages} onPageChange={onPageChange} />
    </div>
  );
}
